"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors = {
    white: '#fff',
    black: '#000',
    fontColor: '#000000',
    background: '#ffffff',
    darkGrey: '#2C2D2A',
    markupForm: '#2C2D2A',
    stoneGrey: '#727771',
    secondary: '#727771',
    cardsDelimiter: '#727771',
    paperGrey: '#F5F1EC',
    lightGreyThird: '#F5F1EC',
    lightGrey: '#D4D4D4',
    borderColor: '#D4D4D4',
    borderGreyFifth: '#D4D4D4',
    lightGreySecond: '#F6F6F6',
    redVivid: '#E73A31',
    primary: '#E73A31',
    redWeb: '#E4251B',
    redHover: '#B61E16',
    redActive: '#A01A13',
    roseFine: '#FDE3D7',
    redBurgundy: '#7A2739',
    green: '#5C7449',
    greenOlive: '#5B5D49',
    greenHay: '#B7C9A9',
    greenLight: '#E5EBE0',
    blueOcean: '#537A93',
    blueMorning: '#A9CDC9',
    blueLight: '#DEE7ED',
    bgLightBlue: '#DEE7ED',
    goldSavannah: '#BA9155',
    goldLight: '#F0E8DB',
    modalShadow: 'rgba(0, 0, 0, 0.8)',
    authModalBackgroundColor: '#fff',
    pinWrapper: '#fff',
    activePinWrapper: '#E4251B',
    inactivePin: '#7A2739',
    oldRoundtripsPinHover: '#405F72',
    oldRoundtripsPinActive: '#375162',
    error: '#E4251B',
    success: '#5C7449',
    imageColorOverlay: 'rgba(231, 58, 49, 0.39)',
};
exports.default = colors;
//# sourceMappingURL=colors.js.map